import React, { useState, useRef, useEffect } from "react";
import "./../managerPage/css/card.css";
import "./../managerPage/css/table.css";
import "./../managerPage/css/form.css";
import "./../managerPage/css/dropdown.css";
import { IoIosSearch } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import img from "../../assets/images/person_four.jpg";
import { IoIosCloseCircle } from "react-icons/io";
import { LuDownload } from "react-icons/lu";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "tippy.js/dist/tippy.css";
import Tippy from "@tippyjs/react";
import autoTable from "jspdf-autotable";
import { TiArrowSortedUp } from "react-icons/ti";
import {
  useGetRepairReportsQuery,
  useGetRepairRequestQuery,
  useGetRepairReportsByAcademyQuery,
  useUpdateScheduleMutation,
  useLazyGetScheduleByRepairIDQuery,
} from "../../slices/maintenanceApiSlice";
import Select from "react-select";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import { toast } from "sonner";

import {
  useGetUserByEmailQuery,
  useGetUsersQuery,
  useGetAcademyQuery,
  useGetDepartmentQuery,
} from "../../slices/userApiSlice";

const SupervisorRReport = () => {
  const [totalTechnicians, setTotalTechnicians] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [editableData, setEditableData] = useState({
    Additional_cost: "",
    Additional_Hour: "",
    Remarks: "",
  });

  const rowsPerPage = 10;

  const { data: repairRequest, refetch: refetchRepairRequest } =
    useGetRepairRequestQuery();
  const { data: academy } = useGetAcademyQuery();
  const selectUserInfo = (state) => state.auth.userInfo || {};
  const getUserEmail = createSelector(
    selectUserInfo,
    (userInfo) => userInfo?.username || "",
  );
  const email = useSelector(getUserEmail);
  const { data: userByEmial } = useGetUserByEmailQuery(email);

  // We need academyId from the user first
  const academyId = userByEmial?.user?.academyId;

  // Use the NEW query that fetches by academyId, skipping until academyId is available
  const {
    data: repairReport,
    isLoading: isLoadingReports,
    refetch: refetchReports,
  } = useGetRepairReportsByAcademyQuery(academyId, {
    skip: !academyId,
  });

  const [updateSchedule] = useUpdateScheduleMutation();
  const [fetchSchedulesByRepairID] = useLazyGetScheduleByRepairIDQuery();

  const { data: departments, isLoading: departmentsLoading } =
    useGetDepartmentQuery();

  const { data: users } = useGetUsersQuery();
  const [data, setData] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  console.log("dataaaa", data);

  useEffect(() => {
    // Rely on the new `repairReport` from academy query
    if (repairReport && repairRequest && academy && users && userByEmial) {
      console.log("🔧 Repair Reports:", repairReport);
      console.log("📋 Repair Requests:", repairRequest);
      console.log("🎓 Academies:", academy);
      console.log("👤 Users:", users);

      const loginAcademyId = userByEmial.user.academyId?.trim().toLowerCase();

      // Since the backend already filters by Academy, we might not need to filter again strictly,
      // but keeping logic safe is fine. `repairReport` now contains ONLY this academy's reports.
      const mergedData = repairReport
        .map((report) => {
          const matchingRequest = repairRequest.find(
            (request) =>
              request.repairID === report.repairID &&
              request.status !== "In Progress",
          );

          // Skip if no matching request or if still in progress
          if (!matchingRequest) return null;

          // 🔍 Count technicians
          let total = 0;
          if (report.technicians) {
            const technicianList = report.technicians
              .split(",")
              .filter((email) => email.trim() !== "");
            total = technicianList.length;
            console.log(
              "👷‍♂ Technicians for Report ID",
              report.repairID,
              ":",
              total,
            );
          }

          // 🏫 Match academyId to academyName
          // (matchingRequest might be undefined if backend returned report but request is missing or 'In Progress' filtered out above)

          // Re-find request if we didn't filter it out
          const matchingReq = repairRequest.find(
            (r) => r.repairID === report.repairID,
          );

          // If we want to strictly follow the old logic of "status !== In Progress", we should keep the check
          if (matchingReq && matchingReq.status === "In Progress") return null;

          const requestAcademyId = matchingReq
            ? matchingReq.academyId?.trim().toLowerCase()
            : loginAcademyId;

          const matchingAcademy = academy
            ? academy.find(
                (a) => a.academyId?.trim().toLowerCase() === requestAcademyId,
              )
            : null;

          return {
            ...report,
            academyId: requestAcademyId,
            academyName: matchingAcademy?.name || "Unknown Academy",
            assetName: matchingReq?.assetName || report.assetName || "N/A",
            area: matchingReq?.area || "N/A",
            description: matchingReq?.description || "N/A",
            totalTechnicians: total,
          };
        })
        .filter(Boolean); // Remove nulls

      console.log("📦 Final Merged Data:", mergedData);
      const sortedFiltered = mergedData.sort((a, b) =>
        b.repairReportID.localeCompare(a.repairReportID),
      );

      setData(sortedFiltered);
    }
  }, [repairReport, repairRequest, academy, users, userByEmial]);

  useEffect(() => {
    if (isLoadingReports) {
      toast.loading("Loading repair reports...", {
        id: "loading-repair-reports",
      });
    } else {
      toast.dismiss("loading-repair-reports");
    }
  }, [isLoadingReports]);

  const handleUpdate = async () => {
    const repairID = modalData?.repairID;

    if (!repairID) {
      console.error("Repair ID is missing.");
      toast.error("Missing ID: Repair ID is missing. Please try again.");
      return;
    }

    setIsUpdating(true); // 👈 start loading
    try {
      const scheduleRes = await fetchSchedulesByRepairID(repairID).unwrap();
      console.log("Schedule response:", scheduleRes);

      // handle different structures
      const scheduleID = Array.isArray(scheduleRes)
        ? scheduleRes[0]?.scheduleID
        : scheduleRes?.scheduleID;

      if (!scheduleID) {
        console.error("Schedule ID not found in response.");
        toast.error(
          "Schedule Not Found: Unable to fetch a schedule for this repair ID.",
        );

        return;
      }

      const updatedSchedule = {
        addcost: editableData.Additional_cost,
        addHours: editableData.Additional_Hour,
        remark: editableData.Remarks,
      };

      const response = await updateSchedule({
        scheduleID,
        updatedSchedule,
      }).unwrap();
      console.log("Update response:", response);

      toast.success("Schedule updated successfully.");
    } catch (error) {
      console.error("Update failed:", error);
      toast.error(
        "Update Failed: Something went wrong while updating the schedule.",
      );
    }
    setIsUpdating(false);
  };

  console.log("dataa", data);

  const sortedData = [...data].sort(
    (a, b) => b.repairReportID - a.repairReportID,
  );

  const filteredData = sortedData.filter((item) => {
    const matchesSearch = Object.values(item).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    );

    return matchesSearch;
  });

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const displayedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );

  const handleSelectRow = (repairReportID) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(repairReportID)
        ? prevSelectedRows.filter((item) => item !== repairReportID)
        : [...prevSelectedRows, repairReportID],
    );
  };

  const handleDeleteSelected = () => {
    const updatedData = data.filter(
      (item) => !selectedRows.includes(item.repairReportID),
    );
    // Update the data with the filtered result after deletion
    setData(updatedData);
    setSelectedRows([]);
  };

  const handleView = (item) => {
    setModalData(item);
  };
  const handleCloseModal = () => {
    setModalData(null);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableData((prev) => ({ ...prev, [name]: value }));
  };

  // Ref for the modal
  const modalRef = useRef(null);

  // *Function to handle PDF download*
  const handleDownloadPDF = () => {
    if (!modalData) return; // Prevent function execution if no data is selected

    const doc = new jsPDF();

    // Add title
    doc.text("Repair Report", 14, 15);

    // Define table headers
    const columns = ["Field", "Value"];

    // Map modalData dynamically into table rows
    const rows = [
      ["RID", modalData.repairReportID],
      ["Asset Name", modalData.assetName],
      ["Start Time", modalData.startTime],
      ["End Time", modalData.endTime],
      ["Date", modalData.finishedDate],
      ["Area", modalData.area],
      ["Total Cost", modalData.totalCost],
      ["Part Used", modalData.partsUsed],
      ["Description", modalData.description],
      ["Total Technicians", modalData.totalTechnicians],
      ["Assigned Technician", modalData.technicians],
    ];

    // Generate the table using autoTable
    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 20,
      theme: "grid",
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185] }, // Blue header background
    });

    // Save the PDF
    doc.save(`Repair_Report_${modalData.repairReportID}.pdf`);
  };

  // download
  const handleDownloadSelected = () => {
    if (selectedRows.length === 0) return;

    const selectedData = data.filter((item) =>
      selectedRows.includes(item.repairReportID),
    );

    const csvContent = [
      [
        "Repair ID",
        "Asset Name",
        "Start Time",
        "End Time",
        "Date",
        "Area",
        "Total Cost",
        "Parts Used",
        "Description",
        "Total Technicians",
        "Assigned Technician",
      ],
      ...selectedData.map((item) => [
        item.repairReportID,
        item.assetName,
        item.startTime,
        item.endTime,
        item.finishedDate,
        item.area,
        item.totalCost,
        item.partsUsed,
        item.description,
        item.totalTechnicians,
        item.technicians,
      ]),
    ]
      .map((row) =>
        row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(","),
      )
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "repair_report.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const [sortOrder, setSortOrder] = useState({ column: null, ascending: true });
  const sortData = (column, ascending) => {
    const sortedData = [...data].sort((a, b) => {
      let valA = a[column];
      let valB = b[column];

      // Normalize: Handle undefined, null, numbers, strings consistently
      if (valA === undefined || valA === null) valA = "";
      if (valB === undefined || valB === null) valB = "";

      // If both are numbers, compare numerically
      if (!isNaN(valA) && !isNaN(valB)) {
        valA = Number(valA);
        valB = Number(valB);
      } else {
        // Otherwise, compare as lowercase strings (for emails, names, etc.)
        valA = valA.toString().toLowerCase();
        valB = valB.toString().toLowerCase();
      }

      if (valA < valB) return ascending ? -1 : 1;
      if (valA > valB) return ascending ? 1 : -1;
      return 0;
    });

    setData(sortedData);
  };

  const handleSort = (column) => {
    const newSortOrder =
      column === sortOrder.column ? !sortOrder.ascending : true;

    setSortOrder({
      column,
      ascending: newSortOrder,
    });

    sortData(column, newSortOrder);
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="p-4 sm:py-6 sm:px-8 space-y-4">
      {/* Header */}
      <div className="space-y-2 mb-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
          <div className="flex items-center gap-3">
            <h1 className="text-xl sm:text-2xl font-bold text-zinc-800">
              Repair Report
            </h1>
          </div>
        </div>
        <p className="text-zinc-600">
          View and analyze repair maintenance reports and statistics
        </p>
      </div>

      <div className="">
        <div className="">
          <div className="flex flex-col lg:flex-row gap-4 mb-6 lg:items-center lg:justify-between">
            <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
              {/* Search Input */}
              <div className="w-full lg:flex-1 lg:min-w-60">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search repair reports..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg pl-10 text-sm sm:text-base"
                  />
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg
                      className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
              <button
                onClick={handleDownloadSelected}
                className="inline-flex items-center px-4 py-2 bg-[#305845] text-white text-sm font-medium rounded-lg hover:bg-[#2a4d3a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#305845] transition-colors"
              >
                <LuDownload className="w-4 h-4 mr-2" />
                Download
              </button>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="overflow-x-auto min-w-0">
              <table className="w-full min-w-max">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Sl. No.
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Asset Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Time
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Area
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Total Cost
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Parts_used
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Description
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {displayedData.map((item, index) => (
                    <tr
                      key={item.repairReportID || index}
                      className="hover:bg-gray-50"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.assetName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {[item.startTime, item.endTime].join(" - ")}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.finishedDate}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.area}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.totalCost}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.partsUsed}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.description}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                          className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          onClick={() => handleView(item)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="pagination">
            <span>{filteredData.length} Results</span>
            <div>
              {[...Array(totalPages).keys()].slice(0, 5).map((num) => (
                <button
                  key={num}
                  className={currentPage === num + 1 ? "active" : ""}
                  onClick={() => setCurrentPage(num + 1)}
                >
                  {num + 1}
                </button>
              ))}
              <span>...</span>
              <button onClick={() => setCurrentPage(totalPages)}>
                {totalPages}
              </button>
            </div>
          </div>
          {selectedRows.length > 0 && (
            <button
              className="delete-selected-btn"
              onClick={handleDeleteSelected}
            ></button>
          )}
        </div>

        {/* Modal for Viewing Request */}
        {modalData && (
          <div className="modal-overlay">
            <div className="modal-content" ref={modalRef}>
              {/* Close Button */}
              <div className="modal-header">
                <h2 className="form-h">Repair Report</h2>
                <button className="close-btn" onClick={handleCloseModal}>
                  <IoIosCloseCircle
                    style={{ color: "#897463", width: "20px", height: "20px" }}
                  />
                </button>
              </div>
              <div className="modal-body" ref={modalRef}>
                <form className="repair-form">
                  <div className="modal-content-field">
                    <label>Asset Name:</label>
                    <input type="text" value={modalData.assetName} readOnly />
                  </div>

                  <div className="modal-content-field">
                    <label>Time</label>
                    <div className="time-input">
                      <input type="text" value={modalData.startTime} readOnly />
                      <input type="text" value={modalData.endTime} readOnly />
                    </div>
                  </div>
                  <div className="modal-content-field">
                    <label>Date</label>
                    <input
                      type="text"
                      value={modalData.finishedDate}
                      readOnly
                    />
                  </div>
                  <div className="modal-content-field">
                    <label>Area</label>
                    <input type="text" value={modalData.area} readOnly />
                  </div>

                  <div className="modal-content-field">
                    <label>Parts used: </label>
                    <input type="text" value={modalData.partsUsed} readOnly />
                  </div>
                  <div className="modal-content-field">
                    <label>Total Technicians</label>
                    <input
                      type="text"
                      value={modalData.totalTechnicians}
                      readOnly
                    />
                  </div>
                  <div className="modal-content-field">
                    <label>Assigned Technicians</label>
                    <input type="text" value={modalData.technicians} readOnly />
                  </div>
                  {/* <div className="modal-content-field">
                  <label>Assigned Supervisor</label>
                  <input
                    type="text"
                    value={modalData.Assigned_supervisor}
                    readOnly
                  />
                </div> */}
                  <div className="modal-content-field">
                    <label>Description:</label>
                    <textarea value={modalData.description} readOnly />
                  </div>
                  <div className="modal-content-field">
                    <label>Total Cost: </label>
                    <input type="text" value={modalData.totalCost} readOnly />
                  </div>
                  <div className="modal-content-field">
                    <label>Additional Informations: </label>
                    <textarea value={modalData.information} readOnly />
                  </div>
                  <div className="modal-content-field">
                    <label>Repaired Images:</label>
                    <div className="TModal-profile-img">
                      {Array.isArray(modalData.images) &&
                      modalData.images.length > 0 ? (
                        modalData.images.map((imgSrc, index) => (
                          <img
                            key={index}
                            src={imgSrc}
                            alt={`Work Order ${index + 1}`}
                            className="TModal-modal-image"
                          />
                        ))
                      ) : modalData.images ? (
                        // If imageUrl is a string, display it as a single image
                        <img
                          src={modalData.images}
                          alt="Work Order"
                          className="TModal-modal-image"
                        />
                      ) : (
                        <p>No image available</p>
                      )}
                    </div>
                  </div>

                  <div className="modal-buttons">
                    <button className="accept-btn" onClick={handleDownloadPDF}>
                      Download
                      <LuDownload style={{ marginLeft: "12px" }} />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SupervisorRReport;
